<template>
  <div class="l-profile">
    <div class="profile">
      <h1>Profile</h1>
      <ul>
        <li>小林鷹氏に従事。 1998年神谷智次郎写真事務所設立。</li>
        <li>広告、CDジャケット、映画ビジュアル、 ポートレート、CF、などで活動。</li>
        <li>個展「Les couleurs 」コダックフォトサロン,「デブリプロジェクト」at artDECO</li>
        <li>APA日本広告写真家協会展 入選「NIKE」、「PARCO」</li>
      </ul>
    </div>
    <div class="advertise">
      <h1>Advertising,Artist</h1>
      <p>
        NIKE、PARCO、資生堂cle de peau、東京ヤクルトスワローズ、BANDAI namco、ワタベウェディング、maxell、
        <br />三菱電機、アサヒビール、サントリー、Canon、Takashimaya、グランベリーモール、
        <br />hoyu Beautylabo Beateen、POLA、Nikon、ハートフォード生命保険、Chrome Hearts、レコチョク、
        <br />かんぽ生命、DHC、パートナーエージェント、スカチャン、MARCJACOBS、ESTEE LAUDER、
        <br />Van Cleef & Arpels、NTTアーバンソリューションズ、学情あさがくナビ、
        <br />
        <br />Kiroro「好きな人」&nbsp;夏木マリ「Piaf2000」&nbsp;ミニモニ「ミニモニソング大百科」&nbsp;モーニング娘。「冬冬モーニング娘。」
        <br />GREAT3 「Quincy」&nbsp;TOKIO「TOK10」&nbsp;V６「Voyager」&nbsp;コブクロ「５２９６」&nbsp;植村花菜「トイレの神様」
        <br />タッキー&翼「TwoYouFourYou」「Ho!サマー」&nbsp;DespairsRay「REDEEMER」
        <br />舞祭組「舞祭組村のわっと！驚く第１笑」&nbsp;ジャニーズJr.「少年たち」
      </p>
    </div>
    <div class="movie">
      <h1>Movie Visual</h1>
      <div class="movie-resume">
        <div class="movie-resume-list">
          <dl>
            <dt>園子温</dt>
            <dd>
              「冷たい熱帯魚」「ヒミズ」
              <br />「地獄でなぜ悪い」「ラブ&ピース」
              <br />「新宿スワン１、２」「ひそひそ星」
              <br />「アンチポルノ」「東京ヴァンパイヤホテル」
              <br />「愛なき森で叫べ」
            </dd>
          </dl>
          <dl>
            <dt>堤幸彦</dt>
            <dd>
              「劇場版SPEC」「SICK’Sサーガ完結編」
              <br />「ファーストラブ」
            </dd>
          </dl>
          <dl>
            <dt>三木聡</dt>
            <dd>
              「図鑑に載ってない虫」「トンスラ」
              <br />「音量を上げろタコ」
            </dd>
          </dl>
          <dl>
            <dt>原田眞人</dt>
            <dd>「わが母の記」「燃えよ剣」</dd>
          </dl>
          <dl>
            <dt>吉田大八</dt>
            <dd>「美しい星」「羊の木」</dd>
          </dl>
          <dl>
            <dt>深田晃司</dt>
            <dd>「海を駆ける」「よこがお」</dd>
          </dl>
          <dl>
            <dt>岸善幸</dt>
            <dd>「ラジオ」「あぁ荒野」</dd>
          </dl>
          <dl>
            <dt>北村龍平</dt>
            <dd>
              「ヴァーサス アンリミテッド」「ALIVE」
              <br />「荒神」
            </dd>
          </dl>
          <dl>
            <dt>月川翔</dt>
            <dd>「君と１００回目の恋」「響」</dd>
          </dl>
          <dl>
            <dt>本木克英</dt>
            <dd>「空飛ぶタイヤ」「しろときいろ」</dd>
          </dl>
          <dl>
            <dt>萩原健太郎</dt>
            <dd>「東京喰種」「さよならまでの３０分」</dd>
          </dl>
          <dl>
            <dt>雑賀俊朗</dt>
            <dd>「クリスマスイブ」「新・麻雀放浪記」</dd>
          </dl>
          <dl>
            <dt>守屋健太郎</dt>
            <dd>
              「シーサイドモーテル」
              <br />「PRINCE OF LEGEND」
            </dd>
          </dl>
          <dl>
            <dt>金子文紀</dt>
            <dd>「大奥」「大奥〜永遠〜」</dd>
          </dl>
          <dl>
            <dt>若松節朗</dt>
            <dd>「子宮の記憶」「空母いぶき」</dd>
          </dl>
          <dl>
            <dt>長谷部安春</dt>
            <dd>「おとり捜査官 北見志穂シリーズ」</dd>
          </dl>
        </div>
        <div class="movie-resume-list">
          <dl>
            <dt>三谷幸喜</dt>
            <dd>「誰かが見ている」</dd>
          </dl>
          <dl>
            <dt>今泉力哉</dt>
            <dd>「あの頃」</dd>
          </dl>
          <dl>
            <dt>江口カン</dt>
            <dd>「ザ ファブル」</dd>
          </dl>
          <dl>
            <dt>清水崇</dt>
            <dd>「魔女の宅急便」</dd>
          </dl>
          <dl>
            <dt>平川雄一朗</dt>
            <dd>「ツナグ」</dd>
          </dl>
          <dl>
            <dt>入江悠</dt>
            <dd>「太陽」</dd>
          </dl>
          <dl>
            <dt>中村義洋</dt>
            <dd>「残穢」</dd>
          </dl>
          <dl>
            <dt>大友啓史</dt>
            <dd>「秘密」</dd>
          </dl>
          <dl>
            <dt>本広克行</dt>
            <dd>「亜人」</dd>
          </dl>
          <dl>
            <dt>白石和彌</dt>
            <dd>「麻雀放浪記２０２０」</dd>
          </dl>
          <dl>
            <dt>耶雲裁治</dt>
            <dd>「刀剣乱舞」</dd>
          </dl>
          <dl>
            <dt>前田弘二</dt>
            <dd>「セーラー服と機関銃」</dd>
          </dl>
          <dl>
            <dt>行定勲</dt>
            <dd>「JUSTICE」</dd>
          </dl>
          <dl>
            <dt>呉有音</dt>
            <dd>「南極の恋」</dd>
          </dl>
          <dl>
            <dt>二階健</dt>
            <dd>「Soundtrack」</dd>
          </dl>
          <dl>
            <dt>川村ケンスケ</dt>
            <dd>
              「記憶の音楽 Gb」「GREAT3 Quincy」
              <br />「V6 Voyager」
            </dd>
          </dl>
          <dl>
            <dt>小林聖太郎</dt>
            <dd>「破門」</dd>
          </dl>
          <dl>
            <dt>藤井道人</dt>
            <dd>「ヤクザと家族」</dd>
          </dl>
          <dl>
            <dt>WOWWOW</dt>
            <dd>
              「ウルトラQ neo」
              <br />「ポイズンドーターホーリーマザー」
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  data: function() {
    return {
      title: 'Profile',
      description: ''
    };
  },
  mounted() {
    this.setMeta(this.title, this.description);
  }
};
</script>

<style lang="scss" scoped>
.l-profile {
  width: 100%;
  max-width: 1080px;
  min-height: 100%;
  margin: 0 auto;
  padding: 0 4% 0;

  @include mq-up() {
    margin-top: 50px;
    padding-bottom: 180px;
  }

  @include mq-down() {
    margin-top: 30px;
    padding-bottom: 60px;
  }
}
h1 {
  margin: 0 0 0.8em;
  color: $white;
  font-weight: $font-weight-bold;

  @include mq-up() {
    @include fz(40);
  }

  @include mq-down() {
    @include fz(20);
  }
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    color: $white;

    @include mq-down() {
      @include fz(13);
    }
  }

  li + li {
    margin-top: 1.5em;
  }
}
p {
  color: $white;
  line-height: 2;

  @include mq-down() {
    @include fz(13);
  }
}
dl {
  @include fz(14);
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  color: $white;

  dt {
    flex-basis: 8em;
    margin: 0;
    font-weight: $font-weight-bold;

    @include mq-down() {
      @include fz(13);
    }
  }

  dd {
    flex: 1;
    margin: 0;

    @include mq-down() {
      @include fz(12);
    }
  }

  & + & {
    margin-top: 1.5em;
  }
}
.profile,
.advertise {
  @include mq-up() {
    margin-bottom: 60px;
  }

  @include mq-down() {
    margin-bottom: 40px;
  }
}
.movie-resume {
  @include mq-up() {
    display: flex;
    flex-wrap: wrap;
  }

  @include mq-down() {
  }
}
.movie-resume-list {
  @include mq-up() {
    flex-basis: calc(100% / 2 - 30px);
  }

  @include mq-down() {
  }

  &:nth-of-type(2) {
    @include mq-up() {
      margin-left: 60px;
    }

    @include mq-down() {
    }
  }
}
</style>
